import type { KindType } from '@/app/cc/_types/types';
import { createFetch } from '@/lib/cc/commonFetch';

interface PostReservationBody {
  name: string;
  phone: string;
  inflow: KindType;
  counselingTime: 'AM' | 'PM' | 'ALL';
  contractFlag: boolean;
  privacyUseFlag: boolean;
  privacyProvideFlag: boolean;
}

export async function postReservation(body: PostReservationBody) {
  const fetch = createFetch('property');
  const data = await fetch('/property/safeCare/cc/reservation/req', {
    method: 'POST',
    body: JSON.stringify(body),
  });
  return data;
}
